<template>
  <div>
    <b-pagination
      pills
      align="center"
      v-model="pagination.currentPage"
      :total-rows="courses.length"
      :per-page="pagination.perPage"
    ></b-pagination>
    <b-row>
      <b-col
        v-for="course in pagedCourses"
        :key="course.courseId"
        :cols="pagination.cols"
        class="d-flex justify-content-center"
      >
        <component
          :is="course.memberCourse ? 'PurchasedCourseCard' : 'PublicCourseCard'"
          :course="course"
          :domain="domain"
          :openCourse="openCourse"
          :cart="cart"
          @operateCart="operateCart"
        />
      </b-col>
    </b-row>
    <b-pagination
      pills
      align="center"
      v-model="pagination.currentPage"
      :total-rows="courses.length"
      :per-page="pagination.perPage"
    ></b-pagination>
  </div>
</template>

<script>
import { getCourses } from "@/api/home";
import PurchasedCourseCard from "@/components/PurchasedCourseCard.vue";
import PublicCourseCard from "@/components/PublicCourseCard.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "CoursesView",
  components: {
    PurchasedCourseCard,
    PublicCourseCard
  },
  data() {
    return {
      /** 购物车按钮显示 */
      cart: {
        in: 'Add to Cart',
        out: 'Remove from Cart'
      },
      hideDelay: parseInt(process.env.VUE_APP_TOAST_HIDE_DELAY),
      title: process.env.VUE_APP_TITLE,
      /** 翻页设定值 */
      pagination: {
        cols: parseInt(process.env.VUE_APP_PAGINATION_COLS),
        perPage: parseInt(process.env.VUE_APP_PAGINATION_PERPAGE),
        currentPage: parseInt(process.env.VUE_APP_PAGINATION_CURRENT),
      },
      /** 语言的所有课程 */
      courses: [],
      /** 打开课程提示 */
      openCourse: process.env.VUE_APP_OPEN_COURSE_TOOLTIP
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('cart', ['orderList']),
    pagedCourses() {
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      return this.courses.slice(start, start + this.pagination.perPage);
    },
    domain() {
      return process.env.VUE_APP_S3_DOMAIN || '';
    }
  },
  mounted() {
    this.getCourses();
  },
  props: ['languages'],
  methods: {
    ...mapMutations('cart', ['addCourse','removeCourse']),
    /** 查询课程及其课列表 */
    getCourses() {
      const langCode = this.$route.params.code;
      getCourses(langCode, this.currentUser.sub)
          .then(response => (this.courses = response))
          .catch(error => console.info(error.message));
    },
    /** 操作购物车，放入或取出 */
    operateCart(course) {
      const order = {
        sub: this.currentUser.sub,
        courseCode: course.courseCode,
        courseName: course.name,
        price: course.price,
        language: this.getLangName(course.courseCode),
        createBy: this.currentUser.username
      };
      /** 状态为不在购物车内时，加入购物车 */
      if (!course.inCart) {
        this.addCourse(order);
        /** 显示提示框，提示加入购物车 */
        const message = `<${course.name}> is added to cart!`;
        const variant = 'success';
        this.showToast(message, variant);
      /** 状态为在购物车内时，取出购物车 */
      } else {
        this.removeCourse(order);
        /** 显示提示框，提示取出购物车 */
        const message = `<${course.name}> is removed from cart!`;
        const variant = 'warning';
        this.showToast(message, variant);
      }
    },
    showToast(message, variant) {
      this.$bvToast.toast(message, {
        title: this.title,
        autoHideDelay: this.hideDelay || 1000,
        solid: true,
        variant: variant,
        toaster: 'b-toaster-top-center'
      });
    },
    /** 根据课程码中的语言信息，显示语言名 */
    getLangName (courseCode) {
      const langCode = courseCode.slice(5, 7);
      const lang = this.languages.find(item => item.code === langCode);
      return lang ? lang.name : langCode;
    }
  }
}
</script>

<style scoped>

</style>
